import {Injectable} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {Observable, Subject} from 'rxjs';
import {Title} from '@angular/platform-browser';
import {TrackingService} from '@services/tracking.service';

// TODO : Improve alert service : https://jasonwatmore.com/post/2019/07/05/angular-8-alert-toaster-notifications
// TODO : Service dedicated for routing : https://reverence23.medium.com/angular-router-log-8b64e1c7521e

@Injectable({
    providedIn: 'root'
})
export class AlertService {
    private subject = new Subject<any>();
    private keepAfterRouteChange = false;
    private lastMessage;

    constructor(private router: Router, private titleService: Title, private trackingService: TrackingService) {
        // clear alert messages on route change unless 'keepAfterRouteChange' flag is true
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                // Remove style from config tools
                document.body.style.overflowY = "auto";
                this.titleService.setTitle("LyBox - Espace utilisateur");
                trackingService.url(event.url);
                if (this.keepAfterRouteChange) {
                    // only keep for a single route change
                    this.keepAfterRouteChange = false;

                    setTimeout(function() {
                        this.subject.next(this.lastMessage);
                    }.bind(this), 500);
                } else {
                    // clear alert message
                    this.clear();
                }
            }
        });
    }

    getAlert(): Observable<any> {
        return this.subject.asObservable();
    }

    success(message: string, keepAfterRouteChange = false) {
        this.keepAfterRouteChange = keepAfterRouteChange;
        this.lastMessage = {type: 'success', text: message};
        this.subject.next(this.lastMessage);
    }

    error(message: string, keepAfterRouteChange = false) {
        this.keepAfterRouteChange = keepAfterRouteChange;
        this.subject.next({type: 'error', text: message});
    }

    clear() {
        // clear by calling subject.next() without parameters
        this.subject.next(false);
    }
}
